import axios from 'axios'
import { i18n } from '@/main.js' 

export default({
    state: {
        teachings: [], // Used for showing available subjects in the teacher home view

        teachingsByUser: [], // Teachings grouped by user. Used for the administrator panel
        teachingsBySubject: [], // Teachings grouped by subject. Used for the administrator panel
    },

    getters: {
        getTeachings(state){ return state.teachings },

        getTeachingsByUser(state){ return state.teachingsByUser },
        getTeachingsBySubject(state){ return state.teachingsBySubject },
    },

    mutations: {
        setTeachings(state, value){ state.teachings = value },

        setTeachingsByUser(state, value){ state.teachingsByUser = value },
        setTeachingsBySubject(state, value){ state.teachingsBySubject = value },
    },

    actions: {
        getTeachings({ commit }, userId){
            commit('setLoading')
            commit('setTeachings', [])
            return new Promise((resolve) => {
                axios.get('/teachings/user/' + userId)
                .then((response) =>{
                    commit('setTeachings', response.data)
                    resolve()
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        getTeachingsByUser({ commit }){
            commit('setLoading')
            commit('setTeachingsByUser', [])

            return new Promise((resolve) => {
                axios.get('/teachings')
                .then((response) =>{
                    var teachingsByUser = response.data.reduce( (grouped, teaching) => {                             // response.data is an array of teachings {userId, subjectId}
                        (grouped[teaching["userId"]] = grouped[teaching["userId"]] || []).push(teaching.subjectId)   //
                        return grouped;                                                                              // teachingsByUser is an object where each value is a userId
                    }, {})                                                                                           // each value in teachingsByUser contains an array of subjectIds teached by userId

                    commit('setTeachingsByUser', teachingsByUser)
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        getTeachingsBySubject({ commit }){
            commit('setLoading')
            commit('setTeachingsBySubject', [])

            return new Promise((resolve) => {
                axios.get('/teachings')
                .then((response) =>{
                    var teachingsBySubject = response.data.reduce( (grouped, teaching) => {                              // response.data is an array of teachings {userId, subjectId}
                        (grouped[teaching["subjectId"]] = grouped[teaching["subjectId"]] || []).push(teaching.userId) //
                        return grouped;                                                                                  // teachingsBySubject is an object where each value is a subjectId
                    }, {})                                                                                               // each value in teachingsBySubject contains an array of userIds who teach subjectId

                    commit('setTeachingsBySubject', teachingsBySubject)
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        updateTeaching({ state, commit, dispatch }, {userId, subjectId, value}){
            if (value)
                dispatch('addTeaching', {userId, subjectId})
            else
                dispatch('deleteTeaching', {userId, subjectId})
        },

        addTeaching({ state, commit, dispatch }, {userId, subjectId}){
            commit('setLoading')

            var teaching = {
                userId: userId,
                subjectId: subjectId
            }

            return new Promise(() => {
                axios.post('/teachings', teaching)
                .then(() => {
                    commit('setSnackBar', {value: true, text: i18n.t('teachingCreated'), color: 'green'})
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        deleteTeaching({ state, commit, dispatch }, {userId, subjectId}){
            commit('setLoading')

            return new Promise(() => {
                axios.delete('/teachings', {
                    params: {
                        userId,
                        subjectId
                    }
                })
                .then(() => {
                    commit('setSnackBar', {value: true, text: i18n.t('teachingRemoved'), color: 'green'})
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },
    },
});
